import React, { Component } from "react";
import Icon from "react-web-vector-icons";
import Popup from "reactjs-popup";
import constants from "../../utils/constants";
import { isNullOrFalse } from "../../utils/general";

import "./popupWin.scss";

const log = require("loglevel").getLogger("Popup");
log.setLevel("error");

class PopupWin extends Component {
  render() {
    const {
      visible,
      contentStyle,
      hideClose,
      onClose,
      closeOnEscape,
      closeOnDocumentClick,
      popupStyle,
      children,
      title,
      titleStyle,
      subtitle,
      footer,
      footerStyle,
      className,
    } = this.props;

    return (
      <Popup
        closeOnEscape={closeOnEscape}
        closeOnDocumentClick={closeOnDocumentClick}
        open={visible}
        onClose={onClose}
        modal
        nested
        contentStyle={Object.assign(popupStyle || {}, {
          padding: 0,
          border: 0,
          backgroundColor: "transparent",
          borderRadius: "15px",
        })}
      >
        <div className={className}>
          <div className="popupContainer">
            <div
              className="titleRow"
              style={{
                position: "sticky",
                top: 0,
                backgroundColor: "white", // Ensure title row background remains visible
                zIndex: 10,
              }}
            >
              {title && (
                <div className="title" style={titleStyle}>
                  {title} <div className="subtitle">{subtitle}</div>
                </div>
              )}
              {isNullOrFalse(hideClose) && (
                <div className="popup-close-btn" onClick={onClose}>
                  <Icon name="close" font="AntDesign" size={12} />
                </div>
              )}
            </div>

            <div
              className="contentContainer"
              style={{
                ...contentStyle,
                overflowY: "auto",
                flexGrow: 1,
                maxHeight: `calc(80vh - ${constants.POPUP_TITLE_HEIGHT}px)`,
              }}
            >
              {children}
            </div>

            {footer && (
              <div className="popupFooter" style={footerStyle}>
                {footer}
              </div>
            )}
          </div>
        </div>
      </Popup>
    );
  }
}

export default PopupWin;
